import {Component, DestroyRef, Inject, Input, OnInit, DOCUMENT} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {MapModeService} from '../../services/map-mode.service';
import {NgEventBus} from 'ng-event-bus';
import {MapToolsService} from '../../services/map-tools.service';
import {MapMode} from '../../../common/models/map-mode.model';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
    selector: 'nlr-map-mode',
    imports: [FormsModule, NgSelectModule],
    providers: [CommonModule],
    templateUrl: './map-mode.component.html',
    styleUrls: ['./map-mode.component.scss']
})
export class MapModeComponent implements OnInit {
    @Input()
    disabled: boolean;
    mapModeList: MapMode[] = [];

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private destroyRef: DestroyRef,
        private eventBus: NgEventBus,
        private mapModeService: MapModeService,
        private mapToolsService: MapToolsService
    ) {}

    ngOnInit() {
        this.mapModeList = [...this.mapModeService.mapModeList];
        this.eventBus
            .on('mapModeInit')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => (this.mapModeList = [...this.mapModeService.mapModeList]));
        this.eventBus
            .on('mapModeChange')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => (this.mapModeList = [...this.mapModeService.mapModeList]));

        this.eventBus
            .on('setMapMode')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.mapModeList = [...this.mapModeService.mapModeList];
            });
    }

    get mapMode() {
        return this.mapModeService.mapMode;
    }

    onSelectMapMode(newMapMode: any) {
        window.setTimeout(() => {
            if (this.document.activeElement) {
                (this.document.activeElement as HTMLElement).blur();
            }
        });

        this.mapToolsService
            .activate('PAGE_SELECT', () => {
                this.mapModeService.mapMode = newMapMode;
                this.mapModeService.mapModeChange();
            })
            .subscribe();
    }
}
